import { Currency } from '@/constants';
import { AbstractModel } from '@/models/abstractModel';
import { IReportRowApi } from '@/types/report';

export class ReportItem extends AbstractModel {
    public balance: number;
    public balanceAgentPc: number;
    public betCount: number;
    public currencyId: number;
    public login: string;
    public playerBalance: number;
    public settledAgentBotCom: number;
    public settledAgentOrderCom: number;
    public settledBotCount: number;
    public settledStakeAgentSum: number;
    public settledStakeSum: number;
    public settledValidStakeSum: number;
    public stakeSum: number;
    public toolUserId: number;
    public userId: number;

    constructor(data: IReportRowApi = {}, requestCurrencyId: number = Currency.Euro) {
        super();
        this.userId = data.ownerId ?? 0;
        this.toolUserId = data.tool_user_id ?? 0;
        this.login = data.login ?? '';
        this.betCount = data.bet_count ?? 0;
        this.settledBotCount = data.settled_bot_count ?? 0;
        this.stakeSum = data.stake_sum ?? 0;
        this.settledStakeSum = data.settled_stake_sum ?? 0;
        this.settledStakeAgentSum = data.settled_stake_agent_sum ?? 0;
        this.settledValidStakeSum = data.settled_valid_stake_sum ?? data.total_valid_stake_sum ?? 0;
        this.settledAgentBotCom = data.settled_agent_bot_com ?? 0;
        this.settledAgentOrderCom = data.settled_agent_order_com ?? 0;
        this.balance = data.balance ?? 0;
        this.balanceAgentPc = data.balance_agent_pc ?? 0;
        this.playerBalance = data.player_balance ?? 0;
        this.currencyId = requestCurrencyId;
    }

    get agentPl(): number {
        return this.balanceAgentPc - this.balance;
    }

    get customerYield(): number {
        if (!this.stakeSum) return 0;
        return (this.playerBalance / this.stakeSum) * 100;
    }

    get settledAgentCom(): number {
        return this.settledAgentBotCom + this.settledAgentOrderCom;
    }

    get totalAgent(): number {
        return this.settledAgentCom + this.balanceAgentPc;
    }
}

export class ReportStats extends ReportItem {}
